import { z } from 'zod';
import { AnalysisResultSchema, ManifestSchema, CollectionProgressSchema, } from './collector.js';
import { WorkflowDetailSchema } from './workflow.js';
import { RefreshStateSchema } from './refresh.js';
import { PreSiteSourcesSchema } from './project-job-links.js';
const Json = z.record(z.string(), z.unknown());
const Result = AnalysisResultSchema.nullable();
export const ProjectsPageSchema = z.object({
    refresh: RefreshStateSchema.optional(),
    items: z.array(z.object({
        project_id: z.string(),
        display_number: z.string(),
        resolved: z.boolean(),
        human_review_complete: z.boolean().default(false),
        open_task_count: z.number().default(0),
        updated_at: z.string(),
        latest_submission_id: z.string().nullable(),
        run_id: z.string().nullable(),
        state: z.string().nullable(),
        progress: Json.nullable(),
        error: Json.nullable(),
        result: Result,
        last_result: Result,
        result_submission_id: z.string().nullable(),
        is_current: z.boolean(),
        collection: CollectionProgressSchema.nullable(),
    })),
    total: z.number(),
    worker: z.object({
        configured: z.boolean().nullable(),
        last_seen_at: z.string().nullable(),
    }),
});
export const ProjectDetailSchema = z.object({
    pre_site_sources: PreSiteSourcesSchema.optional(),
    refresh: RefreshStateSchema.optional(),
    is_current: z.boolean(),
    collection: CollectionProgressSchema.nullable(),
    workflow: WorkflowDetailSchema,
    project: z.object({
        id: z.string(),
        st_project_id: z.string(),
        display_number: z.string(),
        resolved: z.boolean(),
        latest_submission_id: z.string().nullable(),
        latest_run_id: z.string().nullable(),
    }),
    submissions: z.array(z.object({
        id: z.string(),
        client_submission_id: z.string(),
        state: z.string(),
        sequence: z.coerce.number().nullable(),
        manifest: ManifestSchema,
        created_at: z.string(),
        accepted_at: z.string().nullable(),
    })),
    runs: z.array(z.object({
        id: z.string(),
        submission_id: z.string(),
        state: z.string(),
        progress: Json,
        result: Result,
        error: Json.nullable(),
        versions: Json,
        attempts: z.number(),
        created_at: z.string(),
        completed_at: z.string().nullable(),
    })),
    documents: z.array(z.object({
        id: z.string(),
        metadata: Json,
        sha256: z.string(),
        byte_length: z.union([z.number(), z.string()]),
        transcription_state: z.string().nullable(),
        transcription: z.string().nullable(),
        pages: z.unknown(),
        model: z.string().nullable(),
        prompt_hash: z.string().nullable(),
    })),
    snapshots: z.array(z.object({
        id: z.string(),
        provenance: Json,
        payload: Json,
        fingerprint: z.string(),
    })),
    reviews: z.array(z.object({
        resolved: z.boolean(),
        note: z.string(),
        actor_user_id: z.string(),
        created_at: z.string(),
    })),
});
